import { Box, Skeleton, Stack } from '@mui/material';

const SituationCardSkeleton = () => (
  <Skeleton variant="rounded" width="100%" height={120} />
);

const SituationTabsSkeleton = () => (
  <Stack direction="row" spacing={2} sx={{ py: 1.5 }}>
    {Array.from({ length: 4 }, (_, index) => (
      <Skeleton key={index} variant="rounded" width={96} height={32} />
    ))}
  </Stack>
);

const SituationFiltersSkeleton = () => (
  <Stack
    direction="row"
    spacing={1}
    sx={{
      position: { xs: 'static', sm: 'absolute' },
      right: { sm: 0 },
      bottom: { sm: 8 },
      justifyContent: { xs: 'flex-end', sm: 'initial' },
      mt: { xs: 2, sm: 0 },
    }}
  >
    <Skeleton variant="rounded" width={120} height={32} />
    <Skeleton variant="rounded" width={128} height={32} />
  </Stack>
);

export const SituationListSkeleton = ({ count = 3 }: { count?: number }) => (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ position: 'relative' }}>
      <SituationTabsSkeleton />
      <SituationFiltersSkeleton />
    </Box>
    <Stack spacing={1} sx={{ pt: 3 }}>
      {Array.from({ length: count }, (_, index) => (
        <SituationCardSkeleton key={index} />
      ))}
    </Stack>
  </Box>
);
